const options = [
  {
    value: '0-1000',
    label: '0-1000',
  },
  {
    value: '1000-2000',
    label: '1000-2000',
  },
  {
    value: '2000-3000',
    label: '2000-3000',
  },
  {
    value: '3000-4000',
    label: '3000-4000',
  },
]

export {
  options,
}
